import React from "react"
import Grid from "@mui/material/Grid";
import {useTranslation} from "react-i18next";
import FormSection from "../../../components/FormSection";
import Model1Select from "./Model1Select";


export const avalancheDangerColumns = ['l7', 'l8', 'l9'];


const AvalancheDanger = ({formik, model1Registry, warnings, inputDisabled, visibleColumns}) => {
    const {t} = useTranslation(['models1']);

    const L7Registry = model1Registry.data?.l7 ?? [];
    const L8Registry = model1Registry.data?.l8 ?? [];
    const L9Registry = model1Registry.data?.l9 ?? [];

    const isVisible = (column) => (!visibleColumns || visibleColumns?.[column]);

    return <FormSection title={t('model1Form.avalancheDanger')}>
        <Grid container rowSpacing={3} columnSpacing={4}>
            {
                isVisible("l7") &&
                <Grid item xs={12}>
                    <Model1Select name="l7" formik={formik} registry={L7Registry} warnings={warnings}
                                  disabled={inputDisabled}/>
                </Grid>
            }
            {
                isVisible("l8") &&
                <Grid item xs={12}>
                    <Model1Select name="l8" formik={formik} registry={L8Registry} warnings={warnings}
                                  disabled={inputDisabled}/>
                </Grid>
            }
            {
                isVisible("l9") &&
                <Grid item xs={12}>
                    <Model1Select name="l9" formik={formik} registry={L9Registry} warnings={warnings}
                                  disabled={inputDisabled}/>
                </Grid>
            }
        </Grid>
    </FormSection>
}

export default AvalancheDanger;